// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sY9c","type":"styles_type__3p9wT","choices":"styles_choices__3k7Py"};